module.exports = __webpack_public_path__ + "media/images/landing/bg/screens-lafluencers/05-913f95afbcd6286933c1bec5c9b8279b.png";